import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faHistory } from '@fortawesome/pro-duotone-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { sendPasswordReset, setTemporaryPassword } from '../../../../actions/agent';

import { LoaderButton } from '../../../../common/components';

function Password({ details = {} }) {
  const { dataSiteDomain: linkback } = useSelector(store => store.theme);
  const [ resetPwdLoading, setResetPwdLoading ] = useState(false);
  const [ sentPwdMsg, setSentPwdMsg ] = useState();
  const [ sentPwdErr, setSentPwdErr ] = useState();

  const [ tmpPwdLoading, setTmpPwdLoading ] = useState(false);
  const [ tmpPwdMsg, setTmpPwdMsg ] = useState();
  const [ tmpPwdErr, setTmpPwdErr ] = useState();

  const [ showTmpPwd, setShowTmpPwd ] = useState(false);
  const [ tmpPwd, setTmpPwd] = useState('');
  const [ tmpDisabled, setTmpDisabled ] = useState(false);

  useEffect(() => {
    const { is_admin, is_agency_admin, is_staff } = details;
    if (is_admin || is_agency_admin || is_staff) {
      setTmpDisabled(true);
      setTmpPwdErr('You cannot set a temporary password for accounts that have management portal access.');
    } else {
      setTmpDisabled(false);
      setTmpPwdErr('');
    }
  }, [details]);

  function handleResetPassword() {
    const { email } = details;
    setResetPwdLoading(true);
    sendPasswordReset(email, linkback)
      .then(() => {
        setResetPwdLoading(false);
        setSentPwdMsg('Reset password email sent');
      }).catch(() => {
        setResetPwdLoading(false);
        setSentPwdErr('There was an error sending password reset email');
      });
  }

  function handleSetTemporaryPassword() {
    const { username } = details;
    if (!tmpPwd) {
      setTmpPwdErr('Please enter a temporary password.');
      return;
    }
    setTmpPwdLoading(true);
    setTemporaryPassword({ username, temporaryPassword: tmpPwd })
      .then(() => {
        setTmpPwdMsg('Temporary password set. The agent will be required to set a new password their next login.');
        setTmpPwd('');
      }).catch((err = {}) => {
        const { data: { detail } } = err.response;
        setTmpPwdErr(detail || 'There was an error setting a temporary password for the agent.');
      }).finally(() => {
        setTmpPwdLoading(false);
      });
  }

  return (
    <div className="d-flex justify-content-start w-100">
      <div className="d-flex flex-column w-50 m-4 me-0 ms-2">
        <LoaderButton
          text={!showTmpPwd
            ? (
              <div className="d-flex justify-content-center align-items-center">
                <FontAwesomeIcon icon={faEdit} size="lg" className="me-2" />
                Set Temporary Password
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
                Cancel
              </div>
            )}
          className="w-100 btn btn-primary"
          onClick={() => {
            setTmpPwdErr('');
            setTmpPwdMsg('');
            setShowTmpPwd(!showTmpPwd);
          }}
        />
        <div className={`${showTmpPwd ? 'd-flex' : 'd-none'} flex-column w-100 mt-2 fs-4 border p-2`}>
          <div className="d-flex m-1">
            Please enter a temporary password that the agent may use to log in once with.
          </div>
          <div className="d-flex m-1">
            They will be asked to set a new password after using this temporary password once.
          </div>
          <div className="d-flex w-100 mt-2">
            <input
              className="form-control w-75 m-1"
              value={tmpPwd}
              onChange={(e) => setTmpPwd(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSetTemporaryPassword();
                }
              }}
              disabled={tmpDisabled}
            />
            <LoaderButton
              text="Set"
              className="w-25 btn btn-secondary m-1"
              onClick={() => handleSetTemporaryPassword()}
              loading={tmpPwdLoading}
              disabled={tmpDisabled}
            />
          </div>
          {tmpPwdMsg ? (
            <span className="text-success mt-2 fs-5">{tmpPwdMsg}</span>
          ) : null}
          {tmpPwdErr ? (
            <span className="text-danger mt-2 fs-5">{tmpPwdErr}</span>
          ) : null}
        </div>
      </div>
      <div className="d-flex flex-column w-50 m-4">
        <LoaderButton
          text={(
            <div className="">
              <FontAwesomeIcon icon={faHistory} size="lg" className="me-2" />
              Send Password Reset Email
            </div>
          )}
          className="w-100 btn btn-primary"
          onClick={() => handleResetPassword()}
          loading={resetPwdLoading}
        />
        {sentPwdMsg && (
          <span className="text-success mt-1 fs-5">{sentPwdMsg}</span>
        )}
        {sentPwdErr && (
          <span className="text-danger mt-1 fs-5">{sentPwdErr}</span>
        )}
      </div>
    </div>
  );
}
export default Password;
